import React from 'react'
import { TableBodyData, TableHeaderData } from '../../types'
import { AlternateSchemeTableObj, AssetAllocationTableProps, FundHouseTable, topFiveTableObj } from '../../../../redux-store/types/alternative'
import { TableCell, TableRow, Theme, Typography, useTheme } from '@mui/material'
import { formatCurrency } from '../../../../utils/utilityFunctions'
import { useSelector } from 'react-redux'
import { RootStateType } from '../../../../redux-store/reducers'

export const AssetAllocationTableHeader: TableHeaderData[] = [
    {
        id: "categoryType",
        label: "CATEGORY",
        align: "left",
        isSortable: false
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: false
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: false
    },
    {
        id: "gainLoss",
        label: "GAIN/LOSS(%)",
        align: "center",
        isSortable: false
    },

]
export const fundHouseTableHeader: TableHeaderData[] = [
    {
        id: "fundHouseName",
        label: "FUND HOUSE NAME",
        align: "left",
        isSortable: true
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "unrealisedAmount",
        label: "UNREALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },

]

export const topFiveTableHeader: TableHeaderData[] = [
    {
        id: "schemeName",
        label: "SCHEME NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "schemeType",
        label: "FUND TYPE",
        align: "center",
        isSortable: false
    },
    {
        id: "fundHouse",
        label: "FUND HOUSE",
        align: "center",
        isSortable: false
    },
    {
        id: "return",
        label: "Absolute Return",
        align: "center",
        isSortable: false
    },
    {
        id: "exposure",
        label: "EXPOSURE",
        align: "center",
        isSortable: false
    },

]
export const schemeDetailsTableHeader: TableHeaderData[] = [
    {
        id: "schemeName",
        label: "SCHEME NAME",
        align: "left",
        isSortable: true
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "exposure",
        label: "EXPOSURE",
        align: "center",
        isSortable: true
    },
    {
        id: "realisedAmount",
        label: "Gain/Loss (%)",
        align: "center",
        isSortable: true,
    },
    {
        id: "inflow",
        label: "INFLOW",
        align: "center",
        isSortable: true,
    },
    {
        id: "outflow",
        label: "OUTFLOW",
        align: "center",
        isSortable: true,
    },
    {
        id: "unrealisedAmount",
        label: "UNREALISED GAIN/LOSS(%)",
        align: "center",
        isSortable: true,
    },

]

export function AssetAllocationTableComponent(props: AssetAllocationTableProps) {
    const { tableBodyData } = props
    const { palette } = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {tableBodyData?.map((obj, i: number) => {
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    // textWrap: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                })}
                            >
                                {obj?.categoryType}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedValue && `${obj?.investedValue > 0 ? "" : "-"}${formatCurrency({ value: Math.abs(obj?.investedValue), locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.marketValue && `${obj?.marketValue > 0 ? "" : "-"}${formatCurrency({ value: Math.abs(obj?.marketValue), locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: Number(obj?.unRelease) > 0 ? palette.success[800] : palette.error[500],
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.unRelease && `${obj?.unRelease > 0 ? "" : "-"}${formatCurrency({ value: Math.abs(obj?.unRelease), locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}

export function FundHouseTableComponent(props: { tableBodyData: FundHouseTable[], isLoading: boolean }) {
    const { tableBodyData, isLoading } = props
    const { palette } = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {tableBodyData?.map((obj, i: number) => {
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },

                                })}
                            >
                                {obj?.fundHouseName}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedValue && `${obj?.investedValue > 0 ? "" : "-"}${formatCurrency({ value: Math.abs(obj?.investedValue), locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.marketValue && `${obj?.marketValue > 0 ? "" : "-"}${formatCurrency({ value: Math.abs(obj?.marketValue), locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    // color: theme.palette.text.primary,
                                    fontSize: '16px',
                                    color: ((obj?.unRelGainLoss / obj.investedValue) * 100) > 0 ? theme.palette.success[800] : theme.palette.error[500],
                                })}
                            >
                                {obj?.unRelGainLoss && `${obj?.unRelGainLoss > 0 ? "" : "-"}${formatCurrency({ value: Math.abs(obj?.unRelGainLoss), locale, currencyCode })} (${((obj?.unRelGainLoss / obj.investedValue) * 100).toFixed(1)}%)`}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}


export function TopFiveTableComponent(props: { tableBodyData: Array<topFiveTableObj>, isLoading: boolean }) {
    const { tableBodyData, isLoading } = props
    const { palette } = useTheme()
    return (
        <>
            {tableBodyData?.map((obj, i: number) => {

                const folioCheck = obj?.folioNo !== '0' ? `(${obj?.folioNo})` : ''
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },

                                })}
                            >
                                {obj?.schemeName ? `${obj?.schemeName}${folioCheck}` : '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.fundType ? obj?.fundType : 'N/A'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                    textTransform: 'uppercase'
                                })}
                            >
                                {obj?.fundHouse ? obj?.fundHouse : 'N/A'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.return && `${obj?.return.toFixed(2)} %`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.exposure && `${`${obj?.exposure.toFixed(2)}%` || '-'}`}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}

export function SchemeDetailsComponet(props: { tableBodyData: Array<AlternateSchemeTableObj>, isLoading: boolean }) {
    const { tableBodyData, isLoading } = props
    const { palette } = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {tableBodyData?.map((obj, i: number) => {
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[500],
                                    fontSize: '16px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: '400px',
                                    textWrap: 'wrap'
                                })}
                            >
                                {obj?.schemeName ? `${obj?.schemeName}(${obj?.folioNo})` : '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedValue > 0 ? "" : "-"}{formatCurrency({ value: Math.abs(obj?.investedValue), locale, currencyCode })}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                    textTransform: 'uppercase'
                                })}
                            >
                                {obj?.marketValue > 0 ? "" : "-"}{formatCurrency({ value: Math.abs(obj?.marketValue), locale, currencyCode })}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {`${obj?.exposure?.toFixed(2)} %`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    // color: theme.palette.text.primary,
                                    fontSize: '16px',
                                    color: obj.realGainLossPercentage.percentage > 0 ? theme.palette.success[800] : theme.palette.error[500],
                                })}
                            >
                                {obj?.realGainLossPercentage?.percentage?.toFixed(2)}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.inflow > 0 ? "" : "-"}{formatCurrency({ value: Math.abs(obj?.inflow), locale, currencyCode })}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.outflow > 0 ? "" : "-"} {formatCurrency({ value: Math.abs(obj?.outflow), locale, currencyCode })}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    // color: theme.palette.text.primary,
                                    fontSize: '16px',
                                    color: obj.percentage.amount > 0 ? theme.palette.success[800] : theme.palette.error[500],
                                })}
                            >
                                {obj?.percentage?.amount > 0 ? "" : "-"}{formatCurrency({ value: Math.abs(obj?.percentage.amount), locale, currencyCode })}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}
